<template>
  <div class="product-list-card">
    <div class="product-list-card-image">
      <img :src="image" :alt="props.title" v-if="image" />
    </div>

    <div class="product-list-card-content">
      <div class="product-list-card-content-header">
        <div class="product-list-card-content-title">{{ props.title }}</div>
        <div class="product-list-card-content-actions">
          <Button class="p-button-text p-button-secondary" icon="pi pi-ellipsis-h" @click="openMenu" />
          <Menu ref="menu" :model="menuItems" :popup="true" class="width-auto"/>
        </div>
      </div>
      <div class="product-list-card-content-text" v-if="props.description">{{ props.description }}</div>
      <div class="product-list-card-content-price">${{ props.price }}</div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";

const emit = defineEmits(['edit', 'delete']);
const props = defineProps({
  title: {type: String, required: true},
  description: {type: String},
  images: {type: Array, default: () => []},
  price: {type: Number, required: true},
  canDelete: {type: Boolean, default: true},
  canEdit: {type: Boolean, default: true},
});

const menu = ref();
const menuItems = [];

if (props.canEdit) {
  menuItems.push({
    label: 'Edit',
    icon: 'pi pi-fw pi-pencil',
    command: () => emit('edit')
  });
}

if (props.canDelete) {
  menuItems.push({
    label: 'Delete',
    icon: 'pi pi-fw pi-trash',
    command: () => emit('delete')
  });
}

const image = computed(() => props.images[0]?.thumbnail);

const openMenu = (e) => menu.value.toggle(e);
</script>

<style lang="scss" scoped>
@import "../assets/sass/_theme_variables.scss";

.product-list-card {
  width: 100%;
  display: flex;
  margin-top: toRem(16);
  border: 1px solid $shade300;
  border-radius: 12px;
  padding: toRem(16);
}

.product-list-card-image {
  flex: 0 0 auto;
  width: toRem(88);
  height: toRem(88);
  margin-right: toRem(12);

  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: $borderRadius;
  }
}

.product-list-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.product-list-card-content-header {
  display: flex;
}

.product-list-card-content-title {
  font-weight: 500;
}

.product-list-card-content-actions {
  margin-left: auto;

  .p-button {
    padding: 0;
  }
}

.product-list-card-content-text {
  margin-top: toRem(4);
  font-size: toRem(14);
  color: $textThirdColor;
}

.product-list-card-content-price {
  margin-top: auto;
  font-weight: bold;
}
</style>
